import React, {useContext, useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import {Dialog, Item} from '@zebra-fed/zds-react-desktop';
import {SnackbarContent} from "../../styled-components/shared";
import ShowPassword from '../ShowPassword';
import firebaseUtil from '../../data/FirebaseUtil';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Snackbar from '@material-ui/core/Snackbar';
import FormHelperText from '@material-ui/core/FormHelperText';
import config from '../../data/application.properties'
import '@zebra-fed/icons/Alert/index.css';
import {useTranslation} from "react-i18next";
import {MessageResponseContext} from "../../data/MessageLocalizationProvider";
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { Grid, Paper } from '@material-ui/core';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import CloseIcon from '@material-ui/icons/Close';

const KeyNameBold = styled.p`
  font-weight: 600;
  margin: 0px;
`;

const CloseIconCustom = styled(CloseIcon)`
    right: 20px;
    fontSize: 20px;
    position: absolute;
    &:hover {
        cursor: pointer;
    }
`;

const DetailsCard = styled(Paper)`
  margin-top: 4%;
  padding: 15px;
  border: 1px solid #bdbdbd;
  height: 300px;
  overflow: scroll;
  overflow-x: hidden;
  padding: 20px;
  width: 100%
`;

const CustomTextarea = styled.textarea`
    margin-top: 20px;
    border: none;
    border: 1px solid gray;
    border-radius: 5px;
    width: 90%;
    &:focus-visible {
        outline: none !important;
      }
`;

const ModalHeader = styled.div`
    display: flex;
    flex-direction: row;
    height: 50px;
    font-size: 18px;
    background-color: #007ABA;
    color: white;
    align-items: center;
    padding: 0 24px;    
    justify-content: center;
`

const MainContent = styled.div`
  margin-top: 0;
  margin-bottom: -20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
  padding-bottom: 0px;
  padding-top: 0px;
`;

const StyledTextField = styled(TextField)`
  width: 220px;
  display: flex;
`;

const ElementWrapper = styled.div`
    display: flex;
    padding-top: 8px;
`

const RoleSelector = styled(FormControl)`
    width: 220px;
    padding-top: 8px;
`  

export default function ChangeActionTbf(props) {
    const { getAddedNote =()=>{}, clearNote, noteValue,selectedRowData = {}, deviceStatusColorMapper,
    keysToFilter, KeyNameMapper, closeClicked, currentAction, findingBtnClick, soundPlayed } = props;
    const dialogRef = props.modalRef;
    const { t } = useTranslation();
    const { getKeyItem} = useContext(MessageResponseContext);
    const [singleUser, setSingleUser] = useState({
        email: "",
        password: "",
        confirmPassword: "",
        role: "None",
      });
    const [checkErrors, setCheckErrors] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConf, setShowPasswordConf] = useState(false);
    const [addedNoteValue, setAddedNoteValue] = useState("")
    const errors = useRef([]);
    const serverMessage = useRef('');

    useEffect(()=>{
        clearNote &&  setAddedNoteValue("") ;
    }, [clearNote])

    useEffect(()=>{
        setAddedNoteValue(noteValue)
    },[noteValue])


    function handleTextareaChange(e) {
        setAddedNoteValue(e.target.value)
    }

    function handleCancel() {
        dialogRef.current.toggleDialog();
        closeClicked();
        // clearForm();
    }

    const ButtonStyle = {
        cursor: isLoading ? 'wait' : 'pointer',
    }

    function handleAddClick() {
        dialogRef.current.toggleDialog();
        getAddedNote(addedNoteValue)
    }

    return (
        <>
            <Dialog ref={dialogRef}
                key='dialog2'
                width='520px'            
                items={[
                   
                 
                    <Item type='button' style={{...ButtonStyle, backgroundColor: '#757575', width: '102px'}} 
                    onClick={handleCancel} 
                    disabled={isLoading}>{t("close")}</Item>,
                ]}
                headerStyle={{display: 'none' }}
                bodyStyle={{padding: '0px', width: '100%'}}
                // cardStyle={{ marginBottom: '80px'}}
                style={{cursor: isLoading ? 'wait' : 'default'}}>
                <ModalHeader style={{ position: 'relative'}}>
                   {t('deviceDetail.details')}
                   <CloseIconCustom onClick={handleCancel} />
                </ModalHeader>
                <MainContent>
                    <DetailsCard>
                        {Object.keys(selectedRowData).length > 0 && Object.entries(selectedRowData).map((obj, idx) => {
                        for (let index = 0; index < keysToFilter.length; index++) {
                            if (keysToFilter[index] === obj[0]) {
                            return <Grid container spacing={2}>
                                {
                                Object.keys(obj).map((key, i) => (
                                    <Grid item xs={i === 0 ? 4 : 6} >
                                    {i === 0 ? <KeyNameBold>{KeyNameMapper[obj[key]]}</KeyNameBold> : obj[key] ? 
                                    <span style={{color: `${ deviceStatusColorMapper[obj[key]] }`}}>{obj[key] }</span>: '-'} 
                                  </Grid>
                                ))}
                            </Grid>
                            }
                        }
                        }
                        )
                        }
                    </DetailsCard>
                    {currentAction?.label === 'Start finding' &&

                        <Grid container spacing={2} style={{marginTop: '10px'}} >
                        <Grid item xs={12} style={{marginTop: '0px'}}>
                        <button
                                type="primary"
                                style={{ marginLeft: '0px', width: '100%', marginBottom: '0px', background: '#f2ba23', color: 'black' }}
                                onClick={() => findingBtnClick('Play Sound')}
                                className='dropbtn'
                                disabled={soundPlayed || selectedRowData.connectionState === 'Disconnected'}
                            >{t('deviceDetail.playSound')}
                            <VolumeUpIcon style={{ marginLeft: '5px', fontSize: '20px' }} />
                            </button>
                        </Grid>
                        <Grid item xs={6}>
                        <button
                                type="primary"
                                style={{ marginLeft: '0px', background: '#7A7A7A', width: '100%' }}
                                onClick={() => findingBtnClick('Cannot Find')}
                                className='dropbtn'
                            >{t('deviceDetail.cannotFind')}</button>
                        </Grid>
                        <Grid item xs={6}>
                        <button
                            type="primary"
                            style={{ marginLeft: '0px', marginRight: '0px', background: '#00B400', width: '100%' }}
                            onClick={() => findingBtnClick('Device Found')}
                            className='dropbtn'

                            >{t('deviceDetail.deviceFound')}</button>
                        </Grid>
                        </Grid>



                        // <div style={{ display: 'flex', marginTop: '20px' }}>

                            
                        //     <button
                        //         type="primary"
                        //         style={{ marginLeft: '0px' }}
                        //         onClick={() => findingBtnClick('Play Sound')}
                        //         className='dropbtn'
                        //         disabled={soundPlayed || selectedRowData.connectionState === 'Disconnected'}
                        //     >Play Sound
                        //     <VolumeUpIcon style={{ marginLeft: '5px', fontSize: '20px' }} />
                        //     </button>
                        //     <button
                        //         type="primary"
                        //         style={{ marginLeft: '0px', background: '#7A7A7A' }}
                        //         onClick={() => findingBtnClick('Cannot Find')}
                        //         className='dropbtn'
                        //     >Cannot Find</button>
                        //     <button
                        //     type="primary"
                        //     style={{ marginLeft: '0px', marginRight: '0px', background: '#00B400' }}
                        //     onClick={() => findingBtnClick('Device Found')}
                        //     className='dropbtn'

                        //     >Device Found</button>
                        // </div>
                    }
                </MainContent>
                <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={() => setSnackbarOpen(false)}>
                    <SnackbarContent error={true}>{serverMessage.current}</SnackbarContent>
                </Snackbar>
            </Dialog>
        </>
    )
}